var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent-box"},[_c('head-bar',{ref:"headBar",on:{"mineMenuChange":_vm.mineMenuChange}}),_c('div',{staticClass:"main-body"},[_c('router-view',{ref:"routerView",on:{"login":_vm.login}})],1),_c('foot-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }